import React from 'react';

export default function SVGCamera({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      className={`${className ? className : 'text-iconStrong fill-current'} `}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="8" width="20.5444" height="18.6767" rx="1.86767" />
      <path d="M22.8088 19.0729C21.5637 18.3541 21.5637 16.5569 22.8088 15.838L30.513 11.39C31.7581 10.6712 33.3145 11.5697 33.3145 13.0075L33.3145 21.9035C33.3145 23.3412 31.7581 24.2398 30.513 23.5209L22.8088 19.0729Z" />
    </svg>
  );
}
